import {
  FETCH_INTERVIEW_COUNT_REQUEST,
  FETCH_INTERVIEW_COUNT_SUCCESS,
  FETCH_INTERVIEW_COUNT_FAILURE,
  FETCH_INTERVIEW_LISTING_REQUEST,
  FETCH_INTERVIEW_LISTING_SUCCESS,
  FETCH_INTERVIEW_LISTING_FAILURE,
  DELETE_INTERVIEWS_REQUEST,
  DELETE_INTERVIEWS_SUCCESS,
  DELETE_INTERVIEWS_FAILURE,
  CREATE_INTERVIEW_CUSTOM_VIEW,
  CREATE_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  CREATE_INTERVIEW_CUSTOM_VIEW_FAILURE,
  FETCH_INTERVIEW_CUSTOM_VIEW,
  FETCH_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  FETCH_INTERVIEW_CUSTOM_VIEW_FAILURE,
  SELECT_INTERVIEW_CUSTOM_VIEW,
  SELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  SELECT_INTERVIEW_CUSTOM_VIEW_FAILURE,
  DELETE_INTERVIEW_CUSTOM_VIEW,
  DELETE_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  DELETE_INTERVIEW_CUSTOM_VIEW_FAILURE,
  RESET_INTERVIEW_CUSTOM_VIEW,
  FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID,
  FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS,
  FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE,
  EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID,
  EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS,
  EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE,
  UNSELECT_INTERVIEW_CUSTOM_VIEW,
  UNSELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  UNSELECT_INTERVIEW_CUSTOM_VIEW_FAILURE,
  SET_INTERVIEW_DEFAULT_CUSTOM_VIEW,
  DELETE_INTERVIEW_DEFAULT_CUSTOM_VIEW,
  CANCEL_INTERVIEW_REQUEST,
  CANCEL_INTERVIEW_SUCCESS,
  CANCEL_INTERVIEW_FAILURE,
  ADD_INTERVIEW_LOGS_REQUEST,
  ADD_INTERVIEW_LOGS_SUCCESS,
  ADD_INTERVIEW_LOGS_FAILURE,
  COMPLETE_INTERVIEW_REQUEST,
  COMPLETE_INTERVIEW_SUCCESS,
  COMPLETE_INTERVIEW_FAILURE,
  CREATE_INTERVIEW_REQUEST,
  CREATE_INTERVIEW_SUCCESS,
  CREATE_INTERVIEW_FAILURE,
  TRAIN_CREATE_INTERVIEW_REQUEST,
  TRAIN_CREATE_INTERVIEW_SUCCESS,
  TRAIN_CREATE_INTERVIEW_FAILURE,
  RESCHEDULE_INTERVIEW_REQUEST,
  RESCHEDULE_INTERVIEW_SUCCESS,
  RESCHEDULE_INTERVIEW_FAILURE,
  TRAIN_CANCEL_INTERVIEW_REQUEST,
  TRAIN_CANCEL_INTERVIEW_SUCCESS,
  TRAIN_CANCEL_INTERVIEW_FAILURE,
  TRAIN_RESCHEDULE_INTERVIEW_REQUEST,
  TRAIN_RESCHEDULE_INTERVIEW_SUCCESS,
  TRAIN_RESCHEDULE_INTERVIEW_FAILURE,
  UPLOAD_INTERVIEW_ATTACHMENT_REQUEST,
  UPLOAD_INTERVIEW_ATTACHMENT_SUCCESS,
  UPLOAD_INTERVIEW_ATTACHMENT_FAILURE,
  FETCH_INTERVIEW_BY_MULTI_IDS_REQUEST,
  FETCH_INTERVIEW_BY_MULTI_IDS_SUCCESS,
  FETCH_INTERVIEW_BY_MULTI_IDS_FAILURE,
} from "./actionType";

//Interview Counts
export const fetchInterviewCounts = (interviewCountRequest) => ({
  type: FETCH_INTERVIEW_COUNT_REQUEST,
  payload: interviewCountRequest,
});

export const fetchInterviewCountsSuccess = (interviewCount) => ({
  type: FETCH_INTERVIEW_COUNT_SUCCESS,
  payload: interviewCount,
});

export const fetchInterviewCountsFailure = (error) => ({
  type: FETCH_INTERVIEW_COUNT_FAILURE,
  payload: error,
});
//Interview Listing
export const fetchInterviewListingDetails = (interviewListingRequest) => ({
  type: FETCH_INTERVIEW_LISTING_REQUEST,
  payload: interviewListingRequest,
});

export const fetchInterviewListingDetailsSuccess = (interviewListing) => ({
  type: FETCH_INTERVIEW_LISTING_SUCCESS,
  payload: interviewListing,
});

export const fetchInterviewListingDetailsFailure = (error) => ({
  type: FETCH_INTERVIEW_LISTING_FAILURE,
  payload: error,
});

//Delete Interviews
export const deleteInterviews = (interviewId) => ({
  type: DELETE_INTERVIEWS_REQUEST,
  payload: interviewId,
});

export const deleteInterviewsSuccess = (interviewId) => ({
  type: DELETE_INTERVIEWS_SUCCESS,
  payload: interviewId,
});

export const deleteInterviewFailure = (error) => ({
  type: DELETE_INTERVIEWS_FAILURE,
  payload: error,
});

//Create Interview Custom View
export const createInterviewCustomView = (interviewCustomViewRequest) => ({
  type: CREATE_INTERVIEW_CUSTOM_VIEW,
  payload: interviewCustomViewRequest,
});

export const createInterviewCustomViewSuccess = (interviewCustomView) => ({
  type: CREATE_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  payload: interviewCustomView,
});

export const createInterviewCustomViewFailure = (error) => ({
  type: CREATE_INTERVIEW_CUSTOM_VIEW_FAILURE,
  payload: error,
});

//Fetch Interview Custom Views
export const fetchInterviewCustomView = () => ({
  type: FETCH_INTERVIEW_CUSTOM_VIEW,
});

export const fetchInterviewCustomViewSuccess = (interviewCustomViews) => ({
  type: FETCH_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  payload: interviewCustomViews,
});

export const fetchInterviewCustomViewFailure = (error) => ({
  type: FETCH_INTERVIEW_CUSTOM_VIEW_FAILURE,
  payload: error,
});
export const resetInterviewCustomView = () => ({
  type: RESET_INTERVIEW_CUSTOM_VIEW,
});

// Select Interview Custom View
export const selectInterviewCustomView = (interviewCustomViewRequest) => ({
  type: SELECT_INTERVIEW_CUSTOM_VIEW,
  payload: interviewCustomViewRequest,
});

export const selectInterviewCustomViewSuccess = (interviewCustomView) => ({
  type: SELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  payload: interviewCustomView,
});

export const selectInterviewCustomViewFailure = (error) => ({
  type: SELECT_INTERVIEW_CUSTOM_VIEW_FAILURE,
  payload: error,
});

// Delete Interview Custom View
export const deleteInterviewCustomView = (interviewCustomViewId) => ({
  type: DELETE_INTERVIEW_CUSTOM_VIEW,
  payload: interviewCustomViewId,
});

export const deleteInterviewCustomViewSuccess = (interviewCustomViewId) => ({
  type: DELETE_INTERVIEW_CUSTOM_VIEW_SUCCESS,
  payload: interviewCustomViewId,
});

export const deleteInterviewCustomViewFailure = (error) => ({
  type: DELETE_INTERVIEW_CUSTOM_VIEW_FAILURE,
  payload: error,
});

//Fetch Custom View by Id
export const fetchInterviewCustomViewById = (interviewCustomViewId) => ({
  type: FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID,
  payload: interviewCustomViewId,
});

export const fetchInterviewCustomViewByIdSuccess = (interviewCustomView) => ({
  type: FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS,
  payload: interviewCustomView,
});

export const fetchInterviewCustomViewByIdFailure = (error) => ({
  type: FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE,
  payload: error,
});

export const editInterviewCustomViewById = (interviewCustomViewRequest) => ({
  type: EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID,
  payload: interviewCustomViewRequest,
});

export const editInterviewCustomViewByIdSuccess = (interviewCustomView) => ({
  type: EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS,
  payload: interviewCustomView,
});

export const editInterviewCustomViewByIdFailure = (error) => ({
  type: EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE,
  payload: error,
});

export const unselectInterviewCustomView = () => ({
  type: UNSELECT_INTERVIEW_CUSTOM_VIEW,
});

export const unselectInterviewCustomViewSuccess = () => ({
  type: UNSELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS,
});

export const unselectInterviewCustomViewFailure = (error) => ({
  type: UNSELECT_INTERVIEW_CUSTOM_VIEW_FAILURE,
  payload: error,
});

export const setInterviewDefaultCustomView = (interviewCustomViewRequest) => ({
  type: SET_INTERVIEW_DEFAULT_CUSTOM_VIEW,
  payload: interviewCustomViewRequest,
});

export const deleteInterviewDefaultCustomView = () => ({
  type: DELETE_INTERVIEW_DEFAULT_CUSTOM_VIEW,
});

export const cancelInterview = (interviewObject) => ({
  type: CANCEL_INTERVIEW_REQUEST,
  payload: interviewObject,
});

export const cancelInterviewSuccess = (interview, interviewId) => ({
  type: CANCEL_INTERVIEW_SUCCESS,
  payload: {
    interview,
    interviewId,
  },
});

export const cancelInterviewFailure = (error) => ({
  type: CANCEL_INTERVIEW_FAILURE,
  payload: error,
});

export const addInterviewLogs = (interview, setRefreshKey) => ({
  type: ADD_INTERVIEW_LOGS_REQUEST,
  payload: { interview, setRefreshKey },
});

export const addInterviewLogsSuccess = (interview) => ({
  type: ADD_INTERVIEW_LOGS_SUCCESS,
  payload: interview,
});

export const addInterviewLogsFailure = (error) => ({
  type: ADD_INTERVIEW_LOGS_FAILURE,
  payload: error,
});

export const completeInterview = (interviewId, interview) => ({
  type: COMPLETE_INTERVIEW_REQUEST,
  payload: { interviewId, interview },
});

export const completeInterviewSuccess = (interview) => ({
  type: COMPLETE_INTERVIEW_SUCCESS,
  payload: interview,
});

export const completeInterviewFailure = (error) => ({
  type: COMPLETE_INTERVIEW_FAILURE,
  payload: error,
});

export const createInterview = (interview) => ({
  type: CREATE_INTERVIEW_REQUEST,
  payload: interview,
});

export const createInterviewSuccess = (interview) => ({
  type: CREATE_INTERVIEW_SUCCESS,
  payload: interview,
});

export const createInterviewFailure = (error) => ({
  type: CREATE_INTERVIEW_FAILURE,
  payload: error,
});

export const trainCreateInterview = (payload) => {
  return {
    type: TRAIN_CREATE_INTERVIEW_REQUEST,
    attachmentPayload: payload.attachmentPayload,
    interviewPayload: payload.interviewCreatePayload,
    setRefreshKey: payload.setRefreshKey,
  };
};

export const trainCreateInterviewSuccess = (response) => {
  return {
    type: TRAIN_CREATE_INTERVIEW_SUCCESS,
    payload: response,
  };
};

export const trainCreateInterviewFailure = (error) => {
  return {
    type: TRAIN_CREATE_INTERVIEW_FAILURE,
    payload: error,
  };
};

export const rescheduleInterview = (interview, setRefreshKey) => ({
  type: RESCHEDULE_INTERVIEW_REQUEST,
  payload: { interview, setRefreshKey },
});

export const rescheduleInterviewSuccess = (interview) => ({
  type: RESCHEDULE_INTERVIEW_SUCCESS,
  payload: interview,
});

export const rescheduleInterviewFailure = (error) => ({
  type: RESCHEDULE_INTERVIEW_FAILURE,
  payload: error,
});

export const trainCancelInterview = (payload) => ({
  type: TRAIN_CANCEL_INTERVIEW_REQUEST,
  navigate: payload.navigate,
  timeLinePayload: payload.timeLinePayload,
  interviewPayload: payload.interviewPayload,
});

export const trainCancelInterviewSuccess = (response) => ({
  type: TRAIN_CANCEL_INTERVIEW_SUCCESS,
  payload: response,
});

export const trainCancelInterviewFailure = (error) => ({
  type: TRAIN_CANCEL_INTERVIEW_FAILURE,
  payload: error,
});

export const trainRescheduleInterview = (payload) => {
  return {
    type: TRAIN_RESCHEDULE_INTERVIEW_REQUEST,
    attachmentPayload: payload.attachmentPayload,
    reschedulePayload: {
      interviewId: payload?.interviewId,
      interview: payload.rescheduleFormData,
      setRefreshKey: payload.setRefreshKey,
    },
  };
};

export const trainRescheduleInterviewSuccess = (response) => {
  return {
    type: TRAIN_RESCHEDULE_INTERVIEW_SUCCESS,
    payload: response,
  };
};

export const trainRescheduleInterviewFailure = (error) => {
  return {
    type: TRAIN_RESCHEDULE_INTERVIEW_FAILURE,
    payload: error,
  };
};

export const uploadInterviewAttachment = (payload) => {
  return {
    type: UPLOAD_INTERVIEW_ATTACHMENT_REQUEST,
    attachmentFormData: payload,
  };
};

export const uploadInterviewAttachmentSuccess = (response) => {
  return {
    type: UPLOAD_INTERVIEW_ATTACHMENT_SUCCESS,
    payload: response,
  };
};

export const uploadInterviewAttachmentFailure = (error) => {
  return {
    type: UPLOAD_INTERVIEW_ATTACHMENT_FAILURE,
    payload: error,
  };
};

export const fetchInterviewByMultiIds = (payload) => {
  return {
    type: FETCH_INTERVIEW_BY_MULTI_IDS_REQUEST,
    payload,
  };
};

export const fetchInterviewByMultiIdsSuccess = (response) => {
  return {
    type: FETCH_INTERVIEW_BY_MULTI_IDS_SUCCESS,
    payload: response,
  };
};

export const fetchInterviewByMultiIdsFailure = (error) => {
  return {
    type: FETCH_INTERVIEW_BY_MULTI_IDS_FAILURE,
    payload: error,
  };
};
